import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PageApp from '../../../Page';
import { HomeOutlined, UnorderedListOutlined, UploadOutlined, CloseOutlined, CheckOutlined, InfoCircleOutlined } from '@ant-design/icons';
import {Table, Upload, Modal, Tabs, Form, Divider, Button, message, Space, Skeleton, Row, Col, Card, Radio, Typography, Tag, Tooltip, Statistic} from 'antd';
import {obtenerTotales, bitacoraProcesoNomina, recibosEncabezadoNomina} from '../../../../apis/ProcesoNominaApi';
import {emit, downloadRecibo, uploadXml} from '../../../../apis/TimbradoApi';
import AnioPeriodo from '../../../../components/forms/anio_periodo';
import Currency from '../../../../components/common/Currency';
import useCookies from "../../../../hooks/useCookies";
import { status_period } from '@app/constants/period';
import {status_recibo_nomina} from '@app/constants/reciboNomina';
import _ from 'lodash';

const { Text } = Typography;

const routes = [
  {
    href: '',
    title: <>
      <HomeOutlined />
      <span>Inicio</span>
    </>,
  },
  {
    href: '',
    title: (
      <>
        <UnorderedListOutlined />
        <span>Timbrar Nómina</span>
      </>
    ),
  }
];

const TimbrarNomina = () => {
  let navigate = useNavigate();
  const [empleadoCookie] = useCookies("empleado_id");
  const [form] = Form.useForm();
  const [result, setResult] = useState([]);
  const [resultAcumulados, setResultAcumulados] = useState([]);
  const [resultConecepts, setResultConcepts] = useState([]);
  const [periodDetail, setPeriodDetail] = useState(null);
  const [loading, setLoading] = useState(false);
  const [objectSelected, setObjectSelected] = useState(null);
  const [disabledForm, setDisabled] = useState(true);
  const [periodData, setPeriodData] = useState(null);
  const [status, setStatus] = useState(null);
  const [header, setHeader] = useState(null);
  const [empleadosFilter, setEmpleadosFilter] = useState("todos"); // activos, finiquitos, todos
  const [modalUploadXml, setModalUploadXml] = useState(false);
  const [titleUploadXml, setTitleUploadXml] = useState('Cargar XML');
  const [xmlFile, setXmlFile] = useState(null);

  // Estados para la tabla de empleados/nóminas
  const [empleadosData, setEmpleadosData] = useState([]);
  const [bitacoraInfo, setBitacoraInfo] = useState(null);
  const [loadingEmpleados, setLoadingEmpleados] = useState(false);
  
  const [resumen, setResumen] = useState({
    percepcionTotal: 0,
    deduccionTotal: 0,
    totalNeto: 0,
    numEmpleados: 0,
    valeDespensa: 0,
  });
  const [resumen2, setResumen2] = useState({
    empNeto: 0,
    recibosTimbrados: 0,
    timbradosPrueba: 0,
    timbradosError: 0
  });
  const bodyRef = React.createRef();

  const refreshPage = () => {
    // Navegar a la misma ruta para refrescar
    navigate(0);
  };

  useEffect(() => {
    (async () => {
      if (result) {
        var conceptos = result.filter(x => !x.acumulado?.id);
        var acumulados = result.filter(x => x.acumulado?.id > 0);
        setResultConcepts(conceptos);
        setResultAcumulados(acumulados.sort((a, b) => a.concepto?.clave.localeCompare(b.concepto?.clave)));
      }
    })();
  }, [result]);

  useEffect(() => {
    (async () => {
      if (empleadoCookie?.value > 0) {
        var _header = { ...header, odoo_empleado_id: empleadoCookie?.value };
        setHeader(_header);
      }
    })();
  }, [empleadoCookie]);

  useEffect(() => {
    // Simular la carga de datos del resumen cuando cambia el periodo o estatus
    if (periodData && status) {
      cargarResumen();
    }
  }, [periodData, status]);

  // Nuevo useEffect para cargar datos de empleados cuando cambia el header
  useEffect(() => {
    (async () => {
      if (header?.num_periodo > 0) {
        await refreshEmpleadosData();
      }
    })();
  }, [header]);

  const refreshEmpleadosData = async () => {
    if (!header?.periodo_id || !header?.anio || !header?.num_periodo) return;
    
    setLoadingEmpleados(true);
    
    try {
      // Cargar encabezados de recibos
      const responseEncabezado = await recibosEncabezadoNomina(header.periodo_id, header.anio, header.num_periodo);
      if (responseEncabezado.ok) {
        setEmpleadosData(responseEncabezado.payload);
      }

      let data = responseEncabezado.payload;
      let itemsErrorTotal = 0;
      let itemsCerradoTotal = 0;
      let itemsTimbradoTotal = 0;
      data.forEach(item => {
        if(item.estatus == status_recibo_nomina.ERROR){
          itemsErrorTotal++;
        }
        if(item.estatus == status_recibo_nomina.CERRADO){
          itemsCerradoTotal++;
        }
        if(item.estatus == status_recibo_nomina.TIMBRADO){
          itemsTimbradoTotal++;
        }
      });
      setBitacoraInfo({
        usuarios_procesados: itemsTimbradoTotal + itemsErrorTotal,
        usuarios_procesados_exito: itemsTimbradoTotal,
        usuarios_procesados_error: itemsErrorTotal,
        usuarios_esperados: data.length
      });
      setResumen2({
        empNeto: 0,
        recibosTimbrados: itemsTimbradoTotal,
        timbradosPrueba: 0,
        timbradosError: itemsErrorTotal
      });
    } catch (error) {
      console.error('Error al cargar datos de empleados:', error);
      message.error('Error al cargar los datos de empleados');
    }
    
    setLoadingEmpleados(false);
  };

  const cargarResumen = async () => {
    setLoading(true);

    const response = await obtenerTotales(header.periodo_id, header.anio, header.num_periodo);
    if (response.ok) {
       setResumen({
          percepcionTotal: response.payload.percepciones,
          deduccionTotal: response.payload.deducciones,
          totalNeto: response.payload.percepciones - response.payload.deducciones,
          numEmpleados: response.payload.total_empleados,
          valeDespensa: response.payload.vale_despensa || 0,
      });
    }
    setLoading(false);
  };

  const handleCancelar = () => {
    resetBody();
    message.info('Operación cancelada');
  };

  const handleExportar = () => {
    message.info('Exportando errores a Excel...');
    // Lógica para exportar a Excel
  };

  const handleTimbrarOk = async ({concepto}) => {
    setLoading(true);
    const fields = form.getFieldsValue();
    const payload = {
        ...fields
    }
    let response = await emit(payload);
    if(response.ok){
      refreshPage();
      return;
    }
    await refreshEmpleadosData();
    setLoading(false);
  }

  const onChangeEmpleadosFilter = (e) => {
    setEmpleadosFilter(e.target.value);
    // Aquí deberías recargar los datos según el filtro
    cargarResumen();
  };

  const clearData = (data) => {
    const lines = data.filter(line => (line.dias > 0 || line.horas > 0 || line.exento > 0 || line.exento < 0 || line.monto > 0 || line.monto < 0) || line.concepto?.clave == '1002');
    setResult(lines);
  };

  const resetBody = async () => {
    let values = await form.getFieldValue();
    form.resetFields();
    form.setFieldsValue({
      periodo_id: values.periodo_id,
      anio: values.anio,
      num_periodo: values.num_periodo,
    });
  };

  const onBlurHeader = async (values, dataPeriod, status) => {
    setHeader(values);
    if (values?.anio && values?.num_periodo && values?.periodo_id) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
    setPeriodData(dataPeriod);
    setStatus(status?.value);
  };

  const getPeriodDetails = async (periodDetails) => {
    setPeriodDetail(periodDetails);
  };

  // Función para descargar archivos (XML/PDF)
  const getFile = async (object, file) => {
    if (!header?.periodo_id || !header?.anio || !header?.num_periodo) {
      message.error('Faltan datos del periodo');
      return;
    }
    await downloadRecibo(file, header.periodo_id, header.anio, header.num_periodo, object.odoo_empleado_id);
  };

  const beforeUpload = (file, type) => {
    const fileExtension = file.name.split('.').pop().toLowerCase();

    if (type === 'xml') {
      const isCerValid = file.type === 'application/xml' || fileExtension === 'xml';
      if (!isCerValid) {
        message.error('Debes subir un archivo XML válido');
        return Upload.LIST_IGNORE;
      }
    }

    if (type === 'xml') setXmlFile(file);

    return false;
  };

  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  };

  const onFinishUploadXml = async () => {
    if (!header?.periodo_id || !header?.anio || !header?.num_periodo) {
      message.error('Faltan datos del periodo');
      return;
    }
    const xmlBase64 = await fileToBase64(xmlFile);
    const payload = {
      periodo_id: header.periodo_id, 
      anio: header.anio, 
      num_periodo: header.num_periodo, 
      empleado_id: objectSelected.odoo_empleado_id,
      xml_filename: xmlFile.name,
      xml_base64: xmlBase64.split(',')[1],
    };

    // Llamar al servicio de API
    const response = await uploadXml(payload);

    if (response.ok) {
      message.success('Certificados y contraseña actualizados correctamente');
      setModalUploadXml(false); // Cierra el modal y refresca los datos
      setObjectSelected(null);
      await refreshEmpleadosData();
    } else {
      message.error('Error al subir el archivo XML');
      //throw new Error(response.message || 'Error al subir certificados');
    }
  };

  // Columnas para la tabla de empleados/nóminas
  const empleadosColumns = [
    {
      title: 'Empleado',
      dataIndex: 'empleado',
      key: 'empleado',
    },
    {
      title: 'Etapa',
      dataIndex: 'estatus',
      key: 'estatus',
      render: (item, object) => {
        if (object.estatus == status_recibo_nomina.ERROR)
          return <>
            <Tag color={'#f50'} key={'error'}>
              {'Con Error'}
            </Tag>
            <Tooltip title={object.error}>
              <InfoCircleOutlined />
            </Tooltip>
          </>

        if (object.estatus == status_recibo_nomina.EN_PROCESO)
          return <Tag color={'#2db7f5'} key={'en_proceso'}>
            {'En proceso'}
          </Tag>

        if (object.estatus == status_recibo_nomina.PROCESADO)
          return <Tag color={'#87d068'} key={'PROCESADO'}>
            {'Procesado'}
          </Tag>
        if (object.estatus == status_recibo_nomina.CERRADO)
          return <Tag color={'#108ee9'} key={'Cerrado'}>
            {'Cerrado'}
          </Tag>

        if (object.estatus == status_recibo_nomina.TIMBRADO)
          return <Tag color={'purple'} key={'Timbrado'}>
            {'Timbrado'}
          </Tag>

        return '';
      }
    },
    {
      title: 'Estado',
      dataIndex: 'success',
      key: 'success',
      render: (item, object) => {
        if (item) {
          return <CheckOutlined style={{ color: 'green' }} />
        }
        if (!item) {
          return <CloseOutlined style={{ color: 'red' }} />
        }
        return <></>;
      }
    },
    {
      title: 'Acciones',
      dataIndex: 'actions',
      key: 'actions',
      render: (item, object) => {
        return <Space>
          {
            object.estatus == status_recibo_nomina.TIMBRADO && <>
              <Button type='primary' size='small' onClick={() => {
                getFile(object, 'xml');
              }}>XML</Button>
              <Button type='primary' size='small' onClick={() => {
                getFile(object, 'pdf');
              }}>PDF</Button>
            </>
          }
          {
            (object.estatus == status_recibo_nomina.ERROR || object.estatus == status_recibo_nomina.EN_PROCESO) && <>
              <Button type='primary' size='small' onClick={() => {
                setObjectSelected(object);
                setModalUploadXml(true);
              }}>CARGAR XML</Button>
            </>
          }
        </Space>
      }
    }
  ];

  // Columnas originales para los detalles de conceptos (mantener las originales)
  const columns = [
    {
      title: 'Tipo',
      dataIndex: 'concepto',
      key: 'concepto',
      render: (item, object) => {
        if (object.concepto?.tipo_concepto?.descripcion)
          return object.concepto?.tipo_concepto?.descripcion;

        return '';
      }
    },
    {
      title: 'Concepto',
      dataIndex: 'concepto',
      key: 'concepto',
      render: (item, object) => {
        if (object.concepto?.clave)
          return object.concepto?.clave;

        if (object.acumulado?.concepto?.clave)
          return object.acumulado?.concepto?.clave;

        return '';
      }
    },
    {
      title: 'Descripción',
      dataIndex: 'concepto',
      key: 'concepto',
      render: (item, object) => {
        if (object.concepto?.descripcion)
          return object.concepto?.descripcion;

        if (object.acumulado?.concepto?.descripcion)
          return object.acumulado?.concepto?.descripcion;

        return '';
      }
    },
    {
      title: 'Días',
      dataIndex: 'dias',
      key: 'dias',
      render: (item) => {
        var value = item;
        if (item < 0)
          value = item * (-1);
        return value;
      }
    },
    {
      title: 'Exento',
      dataIndex: 'exento',
      key: 'exento',
      render: (item) => {
        var value = item;
        if (item < 0)
          value = item * (-1);
        return value;
      }
    },
    {
      title: 'Horas',
      dataIndex: 'horas',
      key: 'horas',
      render: (item) => {
        var value = item;
        if (item < 0)
          value = item * (-1);
        return value;
      }
    },
    {
      title: 'Monto',
      dataIndex: 'monto',
      key: 'monto',
      render: (item) => {
        var value = item;
        if (item < 0)
          value = item * (-1);
        return <Currency value={value} />;
      }
    },
    {
      title: 'Saldo Anterior',
      dataIndex: 'saldo_anterior',
      key: 'saldo_anterior',
      render: (item) => {
        return <Currency value={item} />;
      }
    },
    {
      title: 'Saldo Nuevo',
      dataIndex: 'saldo_nuevo',
      key: 'saldo_nuevo',
      render: (item) => {
        return <Currency value={item} />;
      }
    },
  ];

  return (
    <PageApp
      routes={routes}
      title={'Timbrar Nómina'}>
      <AnioPeriodo onBlur={onBlurHeader} getPeriodDetails={getPeriodDetails} form={form} disabledForm={objectSelected && objectSelected.id > 0} />
      <Divider />

      {/* Sección de filtros de empleados */}
      {/* <Card className="mb-4">
        <Radio.Group onChange={onChangeEmpleadosFilter} value={empleadosFilter}>
          <Radio value="activos">Activos</Radio>
          <Radio value="finiquitos">Finiquitos</Radio>
          <Radio value="todos">Todos</Radio>
        </Radio.Group>
      </Card> */}

      {/* Estadísticas de la bitácora */}
      {bitacoraInfo && (
        <Row gutter={16} style={{ paddingTop: 10, paddingBottom: 10 }}>
          <Col span={7} offset={1}>
            <Statistic title="Procesados" value={bitacoraInfo.usuarios_procesados} suffix={`/ ${bitacoraInfo.usuarios_esperados}`} />
          </Col>
          <Col span={7}>
            <Statistic title="Correctos" value={bitacoraInfo.usuarios_procesados_exito} suffix={`/ ${bitacoraInfo.usuarios_esperados}`} prefix={<CheckOutlined style={{ color: 'green' }} />} />
          </Col>
          <Col span={7}>
            <Statistic title="Incorrectos" value={bitacoraInfo.usuarios_procesados_error} suffix={`/ ${bitacoraInfo.usuarios_esperados}`} prefix={<CloseOutlined style={{ color: 'red' }} />} />
          </Col>
        </Row>
      )}

      {/* Sección de resumen */}
      {loading ? (
        <Skeleton active={loading} />
      ) : (<>
          {
            resumen && resumen2 && <Card title="Resumen" className="mb-4">
              <Row gutter={16}>
                <Col span={12}>
                  <Row className="mb-2">
                    <Col span={12}><Text>Percepción Total</Text></Col>
                    <Col span={12} style={{ textAlign: 'right' }}><Currency value={resumen.percepcionTotal} /></Col>
                  </Row>
                  <Row className="mb-2">
                    <Col span={12}><Text>Deducción Total</Text></Col>
                    <Col span={12} style={{ textAlign: 'right' }}><Currency value={resumen.deduccionTotal} /></Col>
                  </Row>
                  <Row className="mb-2">
                    <Col span={12}><Text>Total Neto</Text></Col>
                    <Col span={12} style={{ textAlign: 'right' }}><Currency value={resumen.totalNeto} /></Col>
                  </Row>
                  {resumen.valeDespensa > 0 && (
                    <Row className="mb-2">
                      <Col span={12}><Text>Vale de Despensa</Text></Col>
                      <Col span={12} style={{ textAlign: 'right' }}><Currency value={resumen.valeDespensa} /></Col>
                    </Row>
                  )}
                  <Row className="mb-2">
                    <Col span={12}><Text>Num. Empleados</Text></Col>
                    <Col span={12} style={{ textAlign: 'right' }}>{resumen.numEmpleados}</Col>
                  </Row>
                </Col>
                <Col span={8}>
                  <Row className="mb-2">
                    <Col span={16}><Text>Emp Neto &lt;</Text></Col>
                    <Col span={8} style={{ textAlign: 'right' }}>{resumen2.empNeto}</Col>
                  </Row>
                  <Row className="mb-2">
                    <Col span={16}><Text>Recibos Timbrados</Text></Col>
                    <Col span={8} style={{ textAlign: 'right' }}>{resumen2.recibosTimbrados}</Col>
                  </Row>
                  <Row className="mb-2">
                    <Col span={16}><Text>Timbrados Prueba</Text></Col>
                    <Col span={8} style={{ textAlign: 'right' }}>{resumen2.timbradosPrueba}</Col>
                  </Row>
                  <Row className="mb-2">
                    <Col span={16}><Text>Timbrados Error</Text></Col>
                    <Col span={8} style={{ textAlign: 'right' }}>{resumen2.timbradosError}</Col>
                  </Row>
                </Col>
              </Row>
            </Card>
          }
        </>
      )}
      <br />

      {/* Botones de acción */}
      <Row gutter={16} className="mt-4 mb-4">
        <Col>
          <Button style={{ marginLeft: 10 }} type="primary" onClick={handleTimbrarOk} loading={loading} disabled={disabledForm || (!periodData || !(periodData.status === status_period.cerrado || periodData.status === status_period.timbrado_parcial))}>
            {loading ? 'Procesando' : 'Timbrar Nomina'}
          </Button>
          {/* <Button style={{ marginLeft: 10 }} type="primary" onClick={handleTimbrarOk} loading={loading}>
            {loading ? 'Procesando' : 'Timbrar Nomina Prueba'}
          </Button> */}
        </Col>
        <Col >
          <Button
            type="primary"
            onClick={handleExportar}
            style={{ marginBottom: '8px', width: '100%' }}
          >
            Exportar Errores a Excel
          </Button>
        </Col>
        <Col>
          <Button
            onClick={handleCancelar}
          >
            Cancelar
          </Button>
        </Col>
      </Row>

      {/* Tabla principal de empleados/nóminas */}
      {loadingEmpleados ? (
        <Skeleton active={loadingEmpleados} />
      ) : (
        empleadosData.length > 0 && (
          <>
            <Divider />
            <Card title="Nóminas de Empleados">
              <Table 
                dataSource={empleadosData} 
                columns={empleadosColumns} 
                pagination={{ pageSize: 10 }}
                rowKey="id"
              />
            </Card>
          </>
        )
      )}

      {/* Tabla de detalles de conceptos (solo se muestra cuando hay datos individuales seleccionados) */}
      {result.length > 0 && (
        <>
          <Divider />
          <Card title="Detalles del Recibo Seleccionado">
            {loading ? (
              <Skeleton active={loading} />
            ) : (
              <Tabs
                defaultActiveKey="1"
                items={[
                  {
                    key: '1',
                    label: 'Recibo',
                    children: <Table dataSource={resultConecepts} columns={columns} pagination={false} />
                  },
                  {
                    key: '2',
                    label: 'Acumulados',
                    children: <Table dataSource={resultAcumulados} columns={columns} pagination={false} />
                  }
                ]}
              />
            )}
          </Card>
        </>
      )}
      <Modal
      title={titleUploadXml}
      open={modalUploadXml}
      onCancel={() => setModalUploadXml(false)}
      footer={null}
      width={600}
    >
      <Form form={form} layout="vertical" onFinish={onFinishUploadXml}>
        <Form.Item
          label="Archivo .xml"
          required
        >
          <Upload
            beforeUpload={(file) => beforeUpload(file, 'xml')}
            accept=".key,application/xml"
            maxCount={1}
            fileList={xmlFile ? [xmlFile] : []}
            onRemove={() => setXmlFile(null)}
          >
            <Button icon={<UploadOutlined />}>Seleccionar archivo .xml</Button>
          </Upload>
        </Form.Item>
        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            disabled={!xmlFile}
            block
          >
            Cargar
          </Button>
        </Form.Item>
        </Form>
    </Modal>
    </PageApp>
  );
};

export default TimbrarNomina;